import { render } from "./TermsView.vue?vue&type=template&id=0d2126dc&scoped=true"
import script from "./TermsView.vue?vue&type=script&lang=js"
export * from "./TermsView.vue?vue&type=script&lang=js"

import "./TermsView.vue?vue&type=style&index=0&id=0d2126dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2126dc"]])

export default __exports__